import { Base2Presenter } from "core/presenter";
export default class ProductPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      filter: [],
      company: {
        features: []
      }
    };
  }

  onStart() {
    this.load();
  }

  async load() {
    const currentUser = await this.mRuntime.get("currentUser");

    this.enqueue({ company: currentUser.company });
  }

  onCreate() {
    this.navigateTo("app.registration.product.create");
  }

  setLoading = loading => {
    this.enqueue({ loading });
  };

  setFilter = filter => {
    this.enqueue({ filter });
  };

  onRequestBatchImport() {
    this.navigateTo("app.registration.product.batch");
  }

  onRequestInventoryAdjust() {
    this.navigateTo("app.registration.product.inventory.adjust");
  }

  onRequestEditStock() {
    this.navigateTo("app.registration.product.inventory.modify");
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/presenter.js